import { render } from "./MusicList.vue?vue&type=template&id=576be04d"
import script from "./MusicList.vue?vue&type=script&lang=js"
export * from "./MusicList.vue?vue&type=script&lang=js"

import "./MusicList.vue?vue&type=style&index=0&id=576be04d&lang=less&scope=true"

import exportComponent from "D:\\pwrd\\gw-future\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__